import { getAll, update } from 'redux/api/Configs'

import { Dispatch } from 'redux'
import type { TUpdateConfigsRequestBody } from '@homepal/api-contract'

import { ApplicationState } from 'redux/Stores/types'

import { PeriodType } from 'types/GlobalCustomer'
import { Category } from 'types/GlobalDashboardGroup'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

function tryGetAllConfigs() {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    const { fetchStatus } = getState().ConfigStore

    if (fetchStatus === 'fetching' || fetchStatus === 'success') {
      return
    }

    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryUpdateConfig(
  body: TUpdateConfigsRequestBody<PeriodType>,
  category: Category
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update({ data: body })
      .then((response) => {
        dispatch(actions.updateSuccess({ data: response.data.data, category }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSaved))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
      })
  }
}

export const useConfigActions = () => {
  return {
    tryGetAllConfigs: useThunkActions(tryGetAllConfigs),
    tryUpdateConfig: useThunkActions(tryUpdateConfig)
  }
}
